<template lang="html">
  <div id="bolsa-trabajo-page">

    <section class="container oversized-container main-section">
      <div class="row">
        <div class="col-12">
          <div class="col-s-title">
            <h2 class="title">Bolsa de trabajo</h2>
          </div>
        </div>

        <div class="col-md-6 col-lg-4 category-sample-1" v-for="(x, vidInx) in categories" :key="'vidInx-'+vidInx">
          <router-link class="box-category" :to="'/bolsa-de-trabajo/categoria/'+x.id">
            <div class="placed-backg image" v-bind:style="{ backgroundImage: 'url('+x.imageUrl+')' }">
              <img src="public/images/shared/empty.png">
            </div>

            <h5 class="text">{{x.name}}</h5>
          </router-link>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  data(){
    return{
      categories: [],
    }
  },

  methods: {
    getData: function(){
      axios.get(tools.url('/api/categoriesvacants')).then((response)=>{
        this.categories = response.data;
      });
    }
  },

  mounted(){
    this.getData();
  }
}
</script>
